<template>
    <div  style="padding-top:70px;" v-if="wxFalg">
        <div class="top">
            <img :style='mystyle' src="../assets/img2/lo.png"  @click="gohome()" alt="" srcset="">
            <van-button type="default" @click="getLanguage(types)" style="right:60px">
               <span >{{nemeType}}</span>
            </van-button>
            <van-button type="default" style="width: 40px;" @click="isSearch()">
                 <van-icon name="search" />
            </van-button>
      </div>
        <form action="/" v-if="issearchType">
            <van-search
                v-model="searchvalue"
                placeholder="请输入搜索关键词"
                show-action
                shape="round"
                @search="onSearch"
              >
                <div slot="action" @click="onSearch">搜索</div>
            </van-search>
        </form>
        <div  v-if="!NGType">
            <h3 style="font-size:.3rem;margin:0.1rem 0;font-weight: 700;padding:0 0.24rem;font-family:Microsoft YaHei,Helvetica, Arial, Helvetica, sans-serif;color: #4c4948;"><b>{{list.parentname}}</b>   |   {{list.menus_name}}</h3>
            <van-cell style="padding: 0.2rem 0.5rem;font-weight: 600;font-family:Microsoft YaHei,Helvetica, Arial, Helvetica, sans-serif;color: #4c4948;font-size:0.28rem;line-height: 0.56rem;"
                v-for="(item, index) in list.noticelist"
                :key="index"
                :title="item.title"
                @click="godetaill(item.id)"
            />
            <div class="zanwu" v-if="listtyep">
                <h4>暂无数据</h4>
            </div>
            
        </div>
        <div class="zanwu" v-if="NGType">
                <h4 style="font-size: 0.4rem;">under construction...</h4>
        </div>
        <van-overlay :show="show2">
              <van-loading type="spinner" color="#fff" />
         </van-overlay>
    </div>
</template>
<script>
import wx from 'weixin-js-sdk';
import $ from 'jquery'
export default {
    name:'list',
    data(){
        return{
            list:{
                noticelist:'',
            },
            listtyep:false,
            searchvalue:'',
            id:'',
            pid:'',
            types:'',
            value1: '',
            value2: 'a',
            show: false,
            searchvalue:'',
            datas:1,
            show2:false,
            nemeType:'ENG',
            issearchType:false,
            NGType:false,
            mystyle:{marginTop: '10px'},
            wxFalg:true,
        }
    },
    created() {
         this.id = this.$route.query.id
         this.pid = this.$route.query.pid
         this.types = this.$route.query.types
        //  console.log(this.types)
          if(this.types == 1){
                 this.nemeType = 'ENG'
                  this.NGType = false
                    this.getdata()
            }else if (this.types== 2){
               
                this.nemeType = '中文'
                this.NGType = true
            }
        if(this.$route.query.search){
            if(this.$route.query.search=='12357'){
                this.searchvalue = '';
                this.onSearch()
                return;
            }
            this.searchvalue = this.$route.query.search;
            this.onSearch()
            return;
        }
        // console.log(this.id)
        var u = navigator.userAgent;
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        // alert('是否是iOS：'+isiOS);
        if(isiOS){
            if(window.localStorage.getItem('wxNum')){
                this.wxFalg = true;
                window.localStorage.clear()
                //console.log(2)
                // console.log("initwx11")
            }else{
                window.localStorage.setItem('wxNum','b')
                window.location.reload()
            // console.log(1)
            }
        }else{
            this.wxFalg = true;
        }
        
    },
    watch:{
        id:function(newVal,olVal){
           // console.log(1)
            if(this.datas){
                for(let i=0;i<this.datas.length;i++){
                    if(newVal ==this.datas[i].id){
                        // console.log(this.datas[i])
                        this.list = this.datas[i]
                        if(this.list == ''){
                            this.listtyep =true
                        }
                    }
                    
                }
            }
          
            //this.getdata()  index.php/App/AjaxPublic/searchnotice
        }
    },
    methods:{
        gohome(){
            this.$router.push({path:'/home'})
        },
        back(){
            this.$router.back(-1)
        },
        isSearch(){
            this.issearchType = true;
        },
        getLanguage(type){
            if(this.types == 1){
                this.types = 2;
                this.nemeType = '中文'
                this.NGType = true
                // this.More = 'More'
                // console.log(this.types+this.nemeType)
            }else if (this.types== 2){
                this.types = 1;
                this.nemeType = 'ENG'
                this.NGType = false
                 this.getdata()
                // this.More = '了解更多'
                // console.log(this.types+this.nemeType)
            }
           
        },
        godetaill(item){
            // console.log(item)
            window.sessionStorage.setItem("id",this.id)
            window.sessionStorage.setItem("types",this.types)
            this.$router.push({path:'/detaill',query: {id:item,types:this.types,ne:this.list.menus_name}})
        },
        onSearch(){
            //this.$toast('搜索内容为'+this.searchvalue) 
            this.listtyep = false;
            let _this = this
             this.$http({
                methods: 'GET',
                url:'/index.php/App/AjaxPublic/searchnotice?search='+this.searchvalue,
            })
            .then(function (res) {
                console.log(res.data.code)
                if(res.data.code == 1){
                     _this.list.noticelist = res.data.data;
                }else{
                    _this.list.noticelist = ''
                     _this.listtyep =true
                }
            })
            .catch(function (error) {
                console.log(error + '错误');
                 _this.show2 = false
            })
          
        },
        getdata(){
            let _this = this
            this.show2 =true;
             this.listtyep = false;
            this.$http({
                methods: 'GET',
                url:'/index.php/App/AjaxPublic/index?types='+this.types,
            })
            .then(function (res) {
                _this.datas = res.data.data;


                for(let i=0;i<_this.datas.length;i++){

                    if(_this.pid ==_this.datas[i].id){

                        for(let j=0;j<_this.datas[i].children.length;j++){
                            if(_this.id ==_this.datas[i].children[j].id){
                                _this.list = _this.datas[i].children[j]
                                if(_this.list.noticelist == ''){
                                    _this.listtyep =true
                                }
                             }
                         }

                    }

                }
                 _this.show2 = false
                   _this.initWx()
                //console.log(_this.datas);
            })
            .catch(function (error) {
                console.log(error);
                 _this.show2 = false
            })
        },
        hide(){
          this.show = false;
        },
        showPopup() {
           this.show = true;
        },
        golist(data){
        // console.log(data)
            this.id = data
            this.show = false;
        },
        onCancel(){

        },
        gohome(){
            this.$router.push({path:'/home'})
        },
        initWx(){
            var _this = this
            var randNumber = Math.floor(Math.random() * 100000 + 1);
            var getWxData = '';
                $.post(this.baseUrl+"/index.php/App/AjaxPublic/getWxData",{"request_url":window.location.href},function(res){
                if(res.code == 1){
                    getWxData = res.data;
                    wx.config ({  
                        debug : false,    // true:调试时候弹窗  
                        appId : getWxData.appId,  // 微信appid  
                        timestamp : getWxData.timestamp, // 时间戳  
                        nonceStr : getWxData.nonceStr,  // 随机字符串  
                        signature :getWxData.signature, // 签名  
                        jsApiList : [  
                            // 所有要调用的 API 都要加到这个列表中  
                            'onMenuShareTimeline',   // 分享到朋友圈接口  
                            'onMenuShareAppMessage', //  分享到朋友接口  
                            'onMenuShareQQ',         // 分享到QQ接口  
                            'onMenuShareWeibo'       // 分享到微博接口  
                        ]  
                    });  
                    wx.ready (function () {  
                        // 微信分享的数据  
                        var shareData = {  
                            "imgUrl" :"http://xinwen.qingsongjk.com/Public/Xinwen/fenxiang/fenxiang.jpg?v="+randNumber,    // 分享显示的缩略图地址  
                            "link"  : window.location.href,// 分享地址  
                            "desc"  : "清华大学苏州汽车研究院最新技术成果展示",   // 分享描述  _this.list.menus_name
                            "title" : "成果汇编",   // 分享标题  
                            success : function () {  

                            }   
                        };   
                            wx.onMenuShareTimeline (shareData);   
                            wx.onMenuShareAppMessage (shareData);   
                            wx.onMenuShareQQ (shareData);   
                            wx.onMenuShareWeibo (shareData);  
                    });  
                    
                    wx.error(function(res){   
                        //console.log(res);
                        // alert(JSON.stringify(res));
                    });  
                }else{
                }
            },"JSON");  
        }
        // getLanguage(type){
        //     console.log(type)
        //     this.types = type;
        //      this.getdata()
        // }
    },
    mounted() {
        var u = navigator.userAgent;
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if(isiOS){
            this.mystyle.marginTop = '9px'
        }
    },
}
</script>

<style scoped>
.van-cell{
    font-size: 14px
}
.van-loading {
    color: #c8c9cc;
    font-size: 0;
    width: 80px;
    height: 80px;
    /* background: rgba(255,255,255,.7); */
    text-align: center;
    line-height: 80px;
    top: 38%;
    margin: auto;
}
.top{
    background: #fff;
    position: fixed;
    height: 60px;
    width: 100%;
    border-bottom: 1px solid #e3e3e3;
    text-align: left;
    top: 0;
    left: 0;
    z-index: 10;
}
.top img{
    width: 50%;
    margin-left: 20px;
    height: 38px;
}
.zanwu{
    margin-top: 47%;
    color: #999;
}
.zanwu h4{
   margin: 0 auto;
   text-align: center
}
.top button{
    position: absolute;
    right: 15px;
    top: 12px;
    width: 70px;
    padding: 0;
  
}
</style>



// WEBPACK FOOTER //
// src/components/list.vue